import { render, staticRenderFns } from "./s-lateral-panel.vue?vue&type=template&id=8ceec71a"
import script from "./s-lateral-panel.vue?vue&type=script&lang=js"
export * from "./s-lateral-panel.vue?vue&type=script&lang=js"
import style0 from "./s-lateral-panel.vue?vue&type=style&index=0&id=8ceec71a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports